// extracted by mini-css-extract-plugin
export default {"thankyou":"thankyou_thankyou__9Dmv-","video":"thankyou_video__lZwh2","bodyHeader":"thankyou_bodyHeader__TR6Ts"};